// first page and origin of the visit, sent with a sign-up (utils/acquisition.ts)
export default defineNuxtPlugin(() => {
  recordVisit()
})
